import { Component } from '@angular/core';

@Component({
  selector: 'app-secure-blockchain',
  templateUrl: './secure-blockchain.component.html',
  styleUrls: ['./secure-blockchain.component.scss']
})
export class SecureBlockchainComponent {

}
